// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: text for picking a time to meet from the Konvo card and the composer's When line.

import {msg} from '@lingui/core/macro';

export const PICK_TIME_DESCRIPTOR = msg({
	message: 'Pick a time',
	comment:
		'Heading of the time picker on the Konvo card for an email that asks to agree a meeting time. Below it are chips with times when the reader and their colleagues on the email are free.',
});
export const LENGTH_DESCRIPTOR = msg({
	message: 'Meeting length',
	comment: 'Accessible name of the length choice (e.g. 30 m, 1 h, 1.5 h, 2 h) in the meeting time picker.',
});
export const REPLY_WITH_DESCRIPTOR = msg({
	message: 'Reply with {time}',
	comment:
		'Main button on the Konvo card and peek for an email that asks to agree a meeting time: opens the reply with the picked time written in. {time} is a short day and time such as "Tue 10:00".',
});
export const YOU_DESCRIPTOR = msg({
	message: 'You',
	comment: 'The reader, first in the list of people in the meeting time picker, e.g. "You, Berno and Markus are free".',
});
export const YOU_FREE_DESCRIPTOR = msg({
	message: 'You’re free',
	comment:
		'Meeting time picker: at the chosen time only the reader’s own calendar could be checked, and they are free.',
});
export const YOU_BUSY_DESCRIPTOR = msg({
	message: 'You’re busy',
	comment: 'Meeting time picker: at the chosen time the reader is busy and nobody else is.',
});
export const NAMES_FREE_DESCRIPTOR = msg({
	message: '{count, plural, one {{names} is free} other {{names} are free}}',
	comment:
		'Meeting time picker: who is free at the chosen time. {names} is a list such as "You, Berno and Markus"; {count} is how many people it names.',
});
export const NAMES_BUSY_DESCRIPTOR = msg({
	message: '{count, plural, one {{names} is busy} other {{names} are busy}}',
	comment:
		'Meeting time picker: who is busy at the chosen time. {names} is a list such as "Markus" or "You and Markus"; {count} is how many people it names.',
});
export const NAMES_UNKNOWN_DESCRIPTOR = msg({
	message: "{count, plural, one {Can't see {names}'s calendar} other {Can't see the calendars of {names}}}",
	comment:
		'Meeting time picker: colleagues on the email whose calendar could not be read (not shared), so Konvo cannot say whether they are free. {names} is one name or a list.',
});
export const NO_TIME_DESCRIPTOR = msg({
	message: 'No time suits everyone at this length',
	comment: 'Meeting time picker when none of the offered times works for this meeting length.',
});
export const INVITE_SWITCH_DESCRIPTOR = msg({
	message: 'Send a Teams invite with the reply',
	comment:
		'Switch in the meeting time picker on the Konvo card: when the reply is sent, a Teams meeting invite for the picked time goes to everyone on the reply.',
});
export const WHEN_DESCRIPTOR = msg({
	message: 'When',
	comment:
		'Label of a line under To and Cc in the reply composer, for a reply that agrees a meeting time; shows the picked time (and a fallback) and opens the time picker.',
});
export const BACKUP_DESCRIPTOR = msg({
	message: 'or {time}',
	comment:
		'The fallback time on the When line of the reply composer, e.g. "or Wed 14:00"; opens the picker to change the fallback.',
});
export const CHANGE_TIME_DESCRIPTOR = msg({
	message: 'Change the time',
	comment: 'Accessible name of the picked time on the When line of the reply composer; opens the time picker.',
});
export const CHANGE_BACKUP_DESCRIPTOR = msg({
	message: 'Change the other time',
	comment:
		'Accessible name of the fallback time on the When line of the reply composer ("If that doesn’t suit, …"); opens the picker to choose it.',
});
export const OTHER_TIME_DESCRIPTOR = msg({
	message: 'Other time to offer',
	comment:
		'Heading of the time picker when it is opened from the fallback time on the When line of the reply composer.',
});
export const INVITE_DESCRIPTOR = msg({
	message: 'Invite',
	comment:
		'Toggle on the When line of the reply composer: when on, a Teams meeting invite for the picked time goes to everyone on the reply when it is sent.',
});
export const INVITE_ON_TOOLTIP_DESCRIPTOR = msg({
	message: 'A Teams invite goes to everyone on this reply when you send it',
	comment: 'Tooltip of the Invite toggle on the When line of the reply composer while it is on.',
});
export const INVITE_OFF_TOOLTIP_DESCRIPTOR = msg({
	message: 'No invite: only the reply is sent',
	comment: 'Tooltip of the Invite toggle on the When line of the reply composer while it is off.',
});
